import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, vShow as _vShow, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a1c51a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = {
  class: "ant-col",
  style: {"flex":"1 1 auto"}
}
const _hoisted_4 = { class: "ant-row" }
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_7 = { class: "ant-row" }
const _hoisted_8 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-xl-24"
}
const _hoisted_9 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_10 = {
  class: "ant-col ant-col-xs-24",
  style: {"flex":"0 0 88px"}
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  class: "ss-imagem-usuario",
  style: {"background-color":"transparent"}
}
const _hoisted_13 = ["src"]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "REMOVER", -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "ss-imagem-usuario" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "SELECIONAR", -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { class: "ant-row" }
const _hoisted_23 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-24",
  style: {"padding-top":"5px"}
}
const _hoisted_24 = { class: "ant-row" }
const _hoisted_25 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_26 = { class: "ant-input-wrapper ant-input-group" }
const _hoisted_27 = { class: "ant-input-group-addon" }
const _hoisted_28 = { class: "ant-row" }
const _hoisted_29 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_30 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_31 = { class: "ant-row" }
const _hoisted_32 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_33 = { class: "ant-row" }
const _hoisted_34 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_35 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_36 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_campo_telefone = _resolveComponent("campo-telefone")!
  const _component_selecionar_perfil_usuario = _resolveComponent("selecionar-perfil-usuario")!
  const _component_selecionar_empresa = _resolveComponent("selecionar-empresa")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_campo_senha = _resolveComponent("campo-senha")!
  const _component_card = _resolveComponent("card")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_registro_atividade = _resolveComponent("registro-atividade")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      keyboard: false,
      centered: "",
      visible: _ctx.modalBase.computedVisivel,
      "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
      width: 700
    }, {
      title: _withCtx(() => [
        _createTextVNode(" Cadastro de Usuários "),
        _createVNode(_component_a_switch, {
          checked: _ctx.state.usuario.ativo,
          "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.usuario.ativo) = $event)),
          style: {"float":"right"},
          "checked-children": "Ativo",
          "un-checked-children": "Inativo"
        }, null, 8, ["checked"])
      ]),
      closeIcon: _withCtx(() => [
        _createVNode(_component_icone, { nome: "voltar" })
      ]),
      footer: _withCtx(() => [
        ((_ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Incluir && _ctx.telaBase.permissaoDados.incluir)
                  || (_ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Visualizar && _ctx.telaBase.permissaoDados.alterar))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("button", {
                type: "button",
                class: "ant-btn ant-btn-lg ant-btn-secondary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.salvar(true)))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.modalBase.textoBotaoSalvarNovo), 1)
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.salvar(false)))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.modalBase.textoBotaoSalvar), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_skeleton, {
          loading: _ctx.telaBase.carregando
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_tabs, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_tab_pane, {
                  key: "1",
                  tab: (_ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Visualizar) ? 'DADOS PRINCIPAIS' : ''
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form, { layout: "vertical" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                          _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                              _createElementVNode("div", _hoisted_5, [
                                _createVNode(_component_a_form_item, {
                                  label: "Nome",
                                  class: "ss-margin-campos",
                                  rules: [{ required: true }]
                                }, {
                                  default: _withCtx(() => [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      maxlength: "250",
                                      class: "ant-input",
                                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.usuario.nome) = $event))
                                    }, null, 512), [
                                      [_vModelText, _ctx.state.usuario.nome]
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_6, [
                                _createVNode(_component_a_form_item, {
                                  label: "Telefone",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_campo_telefone, {
                                      valor: _ctx.state.usuario.telefone,
                                      "onUpdate:valor": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.usuario.telefone) = $event))
                                    }, null, 8, ["valor"])
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_7, [
                              (_ctx.state.apresentarUnicoPerfil)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                    _createVNode(_component_a_form_item, {
                                      label: "Perfil",
                                      class: "ss-margin-campos",
                                      rules: [{ required: true }]
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_selecionar_perfil_usuario, {
                                          codigoSelecionado: _ctx.state.usuario.perfis[0].codigoPerfilUsuario,
                                          "onUpdate:codigoSelecionado": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.usuario.perfis[0].codigoPerfilUsuario) = $event)),
                                          empresas: [_ctx.state.usuario.perfis[0].codigoEmpresa]
                                        }, null, 8, ["codigoSelecionado", "empresas"])
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true),
                              _withDirectives(_createElementVNode("div", _hoisted_9, [
                                _createVNode(_component_a_form_item, {
                                  label: "Empresas",
                                  class: "ss-margin-campos",
                                  rules: [{ required: true }]
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_selecionar_empresa, {
                                      varias: true,
                                      empresasEspecificas: _ctx.telaBase.empresasDisponiveis,
                                      codigosSelecionados: _ctx.telaBase.empresasSelecionadas,
                                      "onUpdate:codigosSelecionados": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.telaBase.empresasSelecionadas) = $event)),
                                      onChange: _ctx.atualizarSelecaoEmpresas
                                    }, null, 8, ["empresasEspecificas", "codigosSelecionados", "onChange"])
                                  ]),
                                  _: 1
                                })
                              ], 512), [
                                [_vShow, _ctx.telaBase.apresentarEmpresas]
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_10, [
                            (_ctx.state.usuario.imagem)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                  _createElementVNode("div", _hoisted_12, [
                                    (_ctx.state.carrengadoImagem)
                                      ? (_openBlock(), _createBlock(_component_a_spin, {
                                          key: 0,
                                          size: "large"
                                        }))
                                      : (_openBlock(), _createElementBlock("img", {
                                          key: 1,
                                          style: {"object-fit":"cover","width":"80px","height":"80px"},
                                          src: _ctx.state.usuario.imagem,
                                          alt: "Imagem Usuário"
                                        }, null, 8, _hoisted_13))
                                  ]),
                                  _createElementVNode("button", {
                                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.removerImagem && _ctx.removerImagem(...args))),
                                    type: "button",
                                    disabled: _ctx.state.carrengadoImagem,
                                    class: "ant-btn ant-btn-sm ant-btn-primary ant-btn-dangerous ss-btn-imagem-usuario"
                                  }, _hoisted_16, 8, _hoisted_14)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                  _createElementVNode("div", _hoisted_18, [
                                    (_ctx.state.carrengadoImagem)
                                      ? (_openBlock(), _createBlock(_component_a_spin, {
                                          key: 0,
                                          size: "large"
                                        }))
                                      : (_openBlock(), _createBlock(_component_icone, {
                                          key: 1,
                                          style: {"font-size":"30px","color":"#8d8d8d"},
                                          nome: "imagem"
                                        }))
                                  ]),
                                  _createVNode(_component_a_upload, {
                                    "file-list": _ctx.state.listaArquivo,
                                    "onUpdate:fileList": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.listaArquivo) = $event)),
                                    "show-upload-list": false,
                                    multiple: false,
                                    accept: 'image/*',
                                    "before-upload": _ctx.enviarImagem
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("button", {
                                        type: "button",
                                        disabled: _ctx.state.carrengadoImagem,
                                        class: "ant-btn ant-btn-sm ant-btn-primary ss-btn-imagem-usuario"
                                      }, _hoisted_21, 8, _hoisted_19)
                                    ]),
                                    _: 1
                                  }, 8, ["file-list", "before-upload"])
                                ]))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _createVNode(_component_card, { titulo: "INFORMAÇÕES DE ACESSO" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_24, [
                                  _createElementVNode("div", _hoisted_25, [
                                    _createVNode(_component_a_form_item, {
                                      label: "E-mail",
                                      class: "ss-margin-campos",
                                      rules: [{ required: true }]
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_26, [
                                          _createElementVNode("span", _hoisted_27, [
                                            _createVNode(_component_icone, {
                                              class: "ss-icone",
                                              nome: "email"
                                            })
                                          ]),
                                          _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "ant-input",
                                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.usuario.email) = $event))
                                          }, null, 512), [
                                            [_vModelText, _ctx.state.usuario.email]
                                          ])
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_28, [
                                  _createElementVNode("div", _hoisted_29, [
                                    _createVNode(_component_a_form_item, {
                                      label: "Senha",
                                      class: "ss-margin-campos",
                                      rules: [{ required: true }]
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_campo_senha, {
                                          valor: _ctx.state.usuario.senha,
                                          "onUpdate:valor": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.usuario.senha) = $event))
                                        }, null, 8, ["valor"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_30, [
                                    _createVNode(_component_a_form_item, {
                                      label: "Confirmação de Senha",
                                      class: "ss-margin-campos",
                                      rules: [{ required: true }]
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_campo_senha, {
                                          valor: _ctx.state.usuario.confirmacaoSenha,
                                          "onUpdate:valor": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.usuario.confirmacaoSenha) = $event))
                                        }, null, 8, ["valor"])
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_31, [
                          _createElementVNode("div", _hoisted_32, [
                            _createVNode(_component_card, { titulo: "PERFIS" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_33, [
                                  _createElementVNode("div", _hoisted_34, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.usuario.perfis, (perfil, index) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        class: "ant-row",
                                        key: perfil.codigo,
                                        style: {"display":"flex","margin-bottom":"8px"}
                                      }, [
                                        _createElementVNode("div", _hoisted_35, [
                                          _createVNode(_component_a_form_item, {
                                            name: ['perfis', index, 'codigoEmpresa'],
                                            label: "Empresa"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_selecionar_empresa, {
                                                codigoSelecionado: perfil.codigoEmpresa,
                                                "onUpdate:codigoSelecionado": ($event: any) => ((perfil.codigoEmpresa) = $event),
                                                disabled: true
                                              }, null, 8, ["codigoSelecionado", "onUpdate:codigoSelecionado"])
                                            ]),
                                            _: 2
                                          }, 1032, ["name"])
                                        ]),
                                        _createElementVNode("div", _hoisted_36, [
                                          _createVNode(_component_a_form_item, {
                                            name: ['perfis', index, 'codigoPerfil'],
                                            label: "Perfil"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_selecionar_perfil_usuario, {
                                                codigoSelecionado: perfil.codigoPerfilUsuario,
                                                "onUpdate:codigoSelecionado": ($event: any) => ((perfil.codigoPerfilUsuario) = $event),
                                                empresas: [perfil.codigoEmpresa]
                                              }, null, 8, ["codigoSelecionado", "onUpdate:codigoSelecionado", "empresas"])
                                            ]),
                                            _: 2
                                          }, 1032, ["name"])
                                        ])
                                      ]))
                                    }), 128))
                                  ])
                                ])
                              ]),
                              _: 1
                            })
                          ])
                        ], 512), [
                          [_vShow, _ctx.telaBase.apresentarEmpresas]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["tab"]),
                ((_ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Visualizar))
                  ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                      key: "2",
                      tab: "REGISTRO DE ATIVIDADES"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_registro_atividade, {
                          ref: "refRegistroAtividade",
                          apresentarEmpresas: _ctx.telaBase.apresentarEmpresas,
                          empresas: _ctx.telaBase.empresasSelecionadas,
                          apresentarUsuarios: false,
                          codigoUsuario: _ctx.state.usuario.codigo,
                          largura: 1200,
                          altura: 200
                        }, null, 8, ["apresentarEmpresas", "empresas", "codigoUsuario"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_requisicao_modal, {
          visivel: _ctx.modalBase.exibirRequisicaoModal,
          "onUpdate:visivel": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
          apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
          fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso,
          retornoRequisicao: _ctx.modalBase.retornoRequisicao
        }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "retornoRequisicao"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}